import { vars } from "@imwebme/clay-token";
import { useId } from "react";
import { Flex, Label } from "../..";
import { RadioGroupProvider } from "./RadioGroup.provider";
import type { RadioGroupProps } from "./RadioGroup.types";

export const RadioGroup = <T,>({
  children,
  label,
  labelProps,
  direction = "column",
  className,
  sx,
  value,
  onChangeValue,
  as,
  native,
  legend,
}: RadioGroupProps<T>) => {
  const id = useId();
  const deprecatedLabel = label || legend;

  return (
    <RadioGroupProvider value={value} onChangeValue={onChangeValue} name={id}>
      <Flex.Column gap={vars.spacing[1]} className={className} sx={sx} as={as} native={native}>
        {deprecatedLabel && typeof deprecatedLabel === "string" ? (
          <Label text={deprecatedLabel} {...labelProps} />
        ) : (
          deprecatedLabel
        )}

        <Flex.Column flexDirection={direction} gap={vars.spacing[direction === "column" ? 1 : 6]}>
          {children}
        </Flex.Column>
      </Flex.Column>
    </RadioGroupProvider>
  );
};
